<script>
import { API } from '@/net/http';

export default {
  name: 'BillSendDetail',
  props: {
    infoPrepayment: {
      type: Object,
      default: () => {},
    },
    billId: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showBillBox: false,
      coupon: '',
      invalid: false,
    };
  },
  computed: {
    couponShow() {
      return !this.infoPrepayment.details.some(d => d.itemName === 'Discount');
    },
  },
  methods: {
    changeBillBoxShow() {
      this.showBillBox = !this.showBillBox;
    },
    applyCode() {
      let req = {
        billId: this.billId,
        code: this.coupon,
      };
      this.$post(API.coupon, req).then(res => {
        this.invalid = false;
        if (res.success) {
          if (!res.data) {
            this.invalid = true;
          } else {
            this.infoPrepayment.fee = res.data.prepayOut.fee;
            this.infoPrepayment.details = res.data.prepayOut.details;
            this.$emit('update-client-secret', res.data.clientSecret, res.data.prepayOut.fee);
            this.showBillBox = true;
          }
        } else {
          this.invalid = true;
        }
      });
    },
    resetCoupon() {
      let req = {
        billId: this.billId,
      };
      this.$post(API.couponReset, req).then(res => {
        this.invalid = false;
        if (res.success) {
          this.infoPrepayment.fee = res.data.prepayOut.fee;
          this.infoPrepayment.details = res.data.prepayOut.details;
          this.$emit('update-client-secret', res.data.clientSecret, res.data.prepayOut.fee);
        }
      });
    },
  },
};
</script>

<template>
  <div style="border: 1px solid #f2f2f2; padding: 20px 0; margin-bottom: 36px">
    <div class="prepay-box">
      <div class="prepay-left">
        <img src="../../../assets/imgs/prepay-send.png" style="width: 80px; margin: 0 10px" />
        <span>
          <span style="font-size: 14px; font-weight: 400">Send shipping</span>
          <br />
          <span style="font-size: 13px; font-weight: 400; color: #999999">
            {{ infoPrepayment.ctn }} Packages / Each 50lb
          </span>
        </span>
      </div>
      <div class="prepay-right">
        <div>
          <span style="font-size: 18px; font-weight: 700">${{ infoPrepayment.fee }}</span>
          <br />
          <i-button type="text" style="color: #66cccc; padding: 0" @click="changeBillBoxShow()">Show details</i-button>
        </div>
      </div>
    </div>
    <div v-if="showBillBox" class="bill-box">
      <div v-for="item in infoPrepayment.details" :key="item.itemName">
        <div v-if="item.itemName !== 'Discount'" class="prepay-box bill-item">
          <div class="prepay-left">{{ item.itemName }}</div>
          <div class="prepay-right">${{ item.itemFee }}</div>
        </div>
        <div v-else class="prepay-box bill-item" style="height: 60px">
          <span>
            <span style="font-size: 14px; font-weight: 400">Discount</span>
            <i-button type="text" style="color:#66cccc;" @click="resetCoupon">Reset</i-button>
            <br />
            <span style="font-size: 13px; font-weight: 400; color: #999999">{{ item.desc }}</span>
          </span>
          <div class="prepay-right">
            <i-tag color="#00CC02" class="tag">Saving</i-tag>
            <span>${{ item.itemFee }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="couponShow" class="coupon-box" style="margin-left: 25px; margin-top: 10px">
      <p class="title">Add coupon code</p>
      <i-input v-model="coupon" placeholder="coupon code" style="width: 75%; margin-top: 10px" />
      <i-button type="primary" style="margin-left: 10px; margin-top: 8px" size="large" @click="applyCode">
        Apply
      </i-button>
      <br />
      <span v-if="invalid" style="color: red; font-size: 12px">This coupon code is not valid</span>
    </div>
  </div>
</template>

<style scoped lang="less">
@import '../../../assets/css/main.less';
@import '../../../assets/fonts/font.less';
.prepay-box {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  .prepay-left {
    display: flex;
    align-items: center;
  }
  .prepay-right {
    display: flex;
    align-items: center;
    text-align: right;
  }
}
.bill-box {
  margin: 20px 40px;
  background: #fbfbfb;
  .bill-item {
    height: 40px;
    margin: 0 20px;
    border-bottom: 1px solid #f2f2f2;
  }
  .bill-item:last-of-type {
    border-bottom: none;
  }
}
.coupon-box {
  .title {
    .font-regular;
    font-size: 14px;
    font-weight: 400;
    color: #262626;
  }
}
</style>
